import React from 'react'
import SmallSection from '../../../../../../Components/SmallSection'
import moment from 'moment'

const BlockingInfoSection = ({ data }) => {
  const {
    user_who_updated,
    actioned_by_user_id,
    blockedReason,
    created_at: date,
    timezone,
  } = data

  const LinkUserThatBlocked = () => (
    <a
      href={`/dashboard/users/${actioned_by_user_id}`}
      target="_blank"
      rel="noreferrer"
    >
      {user_who_updated}
    </a>
  )

  const blockingInfo = [
    moment
      .utc(date)
      .tz(timezone)
      .format('DD MMM YYYY HH:mm:ss'),
    LinkUserThatBlocked,
    blockedReason,
  ]

  const columns = [
    {
      id: 1,
      columnName: 'Blocked on',
    },
    {
      id: 2,
      columnName: 'Blocked by',
    },
    {
      id: 3,
      columnName: 'Reason',
    },
  ]

  return (
    <SmallSection title="Blocking info" columns={columns} data={blockingInfo} />
  )
}

export default BlockingInfoSection
